import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { Alert } from "@components/Alert/Alert";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.import-deferred`;

const ImportDeferredPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box
      data-testid="drybulk-import-deferred"
      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
    >
      <Typography variant="h5" component="h2">
        {t(`${L}.title`)}
      </Typography>
      <Alert type="info">{t(`${L}.message`)}</Alert>
      <Link component={RouterLink} to="../.." relative="path">
        {t(`${L}.back`)}
      </Link>
    </Box>
  );
};

export default ImportDeferredPage;
